import React from "react";
import { AddAdvisorMasterContainer } from "../../../containers";

const AddAdvisorMaster = (props) => {
  return <AddAdvisorMasterContainer {...props} />;
};

export default AddAdvisorMaster;
